import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Context from '../../../store/context';
import useFetch from '../http/useFetch';
import { setBusiness } from '../../../store/slices/user';
import { setValues } from '../../../store/slices/UI';
import apiMethods from '../../../apis';
import useGet from '../http/useGet';
import { SuccessIntegration } from '../../../components';

const getAccessToken = async businessId => {
  const {
    body: {
      status,
      token: { access: accessToken }
    }
  } = await apiMethods.getDIANConnectionToken[1](businessId);
  return { status, accessToken };
};

const useBelvo = () => {
  const [fetchBusiness, setFetchBusiness] = useState(false);

  const {
    data: updateBusinessData,
    isSuccess: updateBusinessSucess,
    sendRequest: updateBusiness,
    isError: updateBusinessError,
    errorMessage: updateBusinessErrorMessage
  } = useFetch(apiMethods.updateBusiness);

  const {
    modal: { hideModal, showError, showModal },
    toast: { showSuccess }
  } = useContext(Context);
  const dispatch = useDispatch();

  // Corregido: Separado en selectores específicos para evitar re-renders innecesarios
  // El selector anterior retornaba todo el estado, causando re-renders en cualquier cambio
  const { businessId } = useSelector(state => state.userData);
  const { showBelvoWidget, belvoParameters: { integrationStartDate } } = useSelector(state => state.UI);

  const {
    isSuccess: getBusinessSuccess,
    data: getBusinessData,
    isError: getBusinessError,
    errorMessage: getBusinessErrorMessage
  } = useGet(apiMethods.getBusiness, [businessId], fetchBusiness);

  const createWidget = useCallback(
    async dateIntegration => {
      const { status, accessToken } = await getAccessToken(businessId);
      const successCallbackFunction =
        status === 'tokenRequired'
          ? () => setFetchBusiness(true)
          : linkId => updateBusiness(businessId, { newDIANConnection: { linkId, invoicesExtractStartDate: dateIntegration } });
      const onExitCallbackFunction = (...data) => {};
      const onEventCallbackFunction = (...data) => {};
      const config = {
        callback: successCallbackFunction,
        onExit: onExitCallbackFunction,
        onEvent: onEventCallbackFunction,
        external_id: businessId,
        show_close_dialog: false,
        show_abandon_survey: false,
        country_codes: ['CO'],
        institution_types: ['fiscal']
      };

      window.belvoSDK.createWidget(accessToken, config).build();
    },
    [businessId, updateBusiness]
  );

  useEffect(() => {
    if (updateBusinessSucess) {
      dispatch(setBusiness({ businessId, businessData: updateBusinessData }));
      showModal(<SuccessIntegration />);
      //showSuccess('Se creó el link de BELVO');
    } else if (updateBusinessError) {
      showError({ title: 'Crear link de BELVO', description: updateBusinessErrorMessage });
    }
  }, [
    businessId,
    dispatch,
    showModal,
    showError,
    showSuccess,
    updateBusinessData,
    updateBusinessError,
    updateBusinessSucess,
    updateBusinessErrorMessage
  ]);

  useEffect(() => {
    if (getBusinessSuccess) {
      dispatch(setBusiness({ businessId, businessData: getBusinessData }));
      hideModal();
    } else if (getBusinessError) {
      showError({ title: 'Información', description: getBusinessErrorMessage });
    }
  }, [businessId, dispatch, getBusinessData, getBusinessError, getBusinessSuccess, showError, getBusinessErrorMessage, hideModal]);

  useEffect(() => {
    if (showBelvoWidget) {
      const node = document.createElement('script');
      node.src = 'https://cdn.belvo.io/belvo-widget-1-stable.js';
      node.type = 'text/javascript';
      node.async = true;
      node.onload = () => createWidget(integrationStartDate);
      document.body.appendChild(node);
      dispatch(setValues({ showBelvoWidget: false }));
    }
  }, [createWidget, dispatch, integrationStartDate, showBelvoWidget]);
};

export default useBelvo;
